import React, { Component } from 'react'
import axios from '../../../../../data/http/axios'
import AiLoadingIcon from '~/Common-Objects/LoadingIcons/aiLoadingIcon'
import Button from '~/Common-Objects/UI/Forms/Button/Button'
import Icons from '~/Common-Objects/UI/Icons/index'
import NewUserForm from '~/Common-Objects/NewUserForm/newUserForm.jsx'
import Select from '~/Common-Objects/UI/Forms/Select/Select'
import TextArea from '~/Common-Objects/UI/Forms/TextArea/TextArea'
import TierLimitHolder from '~/Common-Objects/UI/Cards/TierLimitHolder'
import SiteVars from '~/Classes/siteVars'
import i18n from '~/i18n'
import Industries from '~/Classes/industries'
import { connect } from 'react-redux'
import tierPermissions from '~/Classes/tierPermissions'
import * as siteMaster from '~/data/actions/siteActions' //now we can use user actions here
import { textDecoration } from '~/Classes/dragAndDropDefaults'

@connect((store) => {
    return { accountMaster: store.accountMaster }
})
class AiContentGenerator extends Component {
    constructor(props) {
        super(props)
        this.mainRef = React.createRef()
        this.state = {
            industry: '',
            text: '',
            generatingText: false,
            generatedText: '',
            hasGeneratedText: false,
            generatingTextError: '',

            contentType: '',
            contentTone: '',

            messages: [],

            history: [],
            showHistory: false,
            historyCnt: 0,
            errorHolder: null,
            approveDrawer: null,
            lookUpsthisMonth: 0,
            allowedLookUps: 0,
            remaining: 0,
            drawerProperties: null
        }

        this.updateInput = this.updateInput.bind(this)
        this.generateText = this.generateText.bind(this)
        this.goInsert = this.goInsert.bind(this)
        this.tryAgain = this.tryAgain.bind(this)
        this.getHistoryCount = this.getHistoryCount.bind(this)
        this.getHistory = this.getHistory.bind(this)
        this.tierError = this.tierError.bind(this)

        this.copyGenerated = this.copyGenerated.bind(this)
        this.updateDrawerProperties = this.updateDrawerProperties.bind(this)
        this.rafId = null
    }

    componentDidMount() {
        this.getQuota()
        let contentType = ''
        if (this.props.contentType) contentType = this.props.contentType
        this.setState({ industry: 'Other', contentType, contentTone: 'professional' }, this.getHistoryCount)
        this.updateDrawerProperties()
        window.addEventListener('scroll', this.handleScroll, true)
        window.addEventListener('resize', this.handleResize)
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.handleScroll, true)
        window.removeEventListener('resize', this.handleResize)
        if (this.rafId) {
            cancelAnimationFrame(this.rafId)
        }
    }

    handleScroll = () => {
        if (this.rafId) {
            cancelAnimationFrame(this.rafId)
        }
        this.rafId = requestAnimationFrame(() => {
            this.updateDrawerProperties()
        })
    }

    handleResize = () => {
        if (this.rafId) {
            cancelAnimationFrame(this.rafId)
        }
        this.rafId = requestAnimationFrame(() => {
            this.updateDrawerProperties()
        })
    }

    updateDrawerProperties() {
        if (this.mainRef.current) {
            const rect = this.mainRef.current.getBoundingClientRect()
            this.setState({
                drawerProperties: {
                    width: rect.width,
                    xPos: rect.left
                }
            })
        }
    }
    updateInput(ev) {
        this.setState({
            generatingTextError: '',
            [ev.target.name]: ev.target.value
        })
    }

    getGeneratedPlainText() {
        // Convert generated HTML to plain text for follow-up prompts
        const temp = document.createElement('div')
        temp.innerHTML = this.state.generatedText || ''
        return temp.textContent || temp.innerText || ''
    }

    async getQuota() {
        let aiQuota = await axios.get('/ai/quota')
        this.setState({
            lookUpsthisMonth: aiQuota.data.lookUpsthisMonth,
            allowedLookUps: aiQuota.data.allowedLookUps,
            remaining: aiQuota.data.remaining
        })
    }
    async getHistoryCount() {
        let historyCnt = await axios.get('/ai/history/count?contentType=heading,article,paragraph,none')
        this.setState({ historyCnt: historyCnt.data.count })
    }
    async getHistory() {
        let history = await axios.get('/ai/history?contentType=heading,article,paragraph,none')
        this.setState({ history: history.data, showHistory: true })
    }

    async generateText(actionType = 'new', actionValue = null) {
        if (!this.props.accountMaster.accountMaster.approved) {
            // show questionnaire

            this.props.dispatch(
                siteMaster.alterFullpage(
                    <NewUserForm
                        from='campaign'
                        finish={() => {
                            this.props.dispatch(siteMaster.alterFullpage(undefined))
                        }}
                    />
                )
            )
        } else {
            this.setState({ generatingText: true })
            try {
                let promptToSend = this.state.text

                let newMessages = [...this.state.messages]
                newMessages.push({ role: 'user', content: promptToSend })

                let selectedText = this.props.selectedText ? this.props.selectedText : ''
                if (newMessages.length > 1) {
                    selectedText = null
                }

                const requestData = {
                    messages: newMessages,
                    contentTone: this.state.contentTone || 'professional',
                    industry: this.state.industry,
                    contentType: this.state.contentType,
                    actionType: actionType,
                    actionValue: actionValue,
                    selectedText: selectedText
                }

                let response = await axios.post('/ai/template/generatetext', requestData)
                if (!Array.isArray(response.data.messages)) {
                    throw new Error('No response')
                }
                this.setState(
                    {
                        generatingText: false,
                        messages: response.data.messages,
                        generatedText: response.data.messages[response.data.messages.length - 1].content,
                        hasGeneratedText: true,
                        text: ''
                    },
                    this.getHistoryCount,
                    this.getQuota
                )
            } catch (err) {
                console.log(err)
                let generatingTextError = ''
                if (err && err.data && err.data.error && err.data.error.err) {
                    this.tierError(err.data.error)
                    return
                }
                if (err && err.data && err.data.error && typeof err.data.error == 'string')
                    generatingTextError = err.data.error
                this.setState({
                    generatingText: false,
                    generatedText: '',
                    hasGeneratedText: false,
                    generatingTextError: generatingTextError
                })
            }
        }
    }

    tierError(err) {
        let userPermissions = tierPermissions('users', this.props.accountMaster)
        let errorHolder = (
            <TierLimitHolder
                darkmode={true}
                type={'AI Lookup'}
                err={err.err}
                allowedNumber={err.allowedNumber}
                tierName={userPermissions.tierName}
            />
        )
        this.setState({ errorHolder: errorHolder })
    }

    goInsert(generatedText) {
        this.props.insertText(generatedText)
    }

    tryAgain() {
        this.setState({
            generatedText: '',
            hasGeneratedText: false,
            generatingText: false,
            text: '',
            forceStandardMode: true
        })
    }

    copyGenerated() {
        const content = this.state.generatedText || ''
        if (!content) return
        const textToCopy = content
        if (navigator && navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(textToCopy)
        } else {
            const textarea = document.createElement('textarea')
            textarea.value = textToCopy
            document.body.appendChild(textarea)
            textarea.select()
            try {
                document.execCommand('copy')
            } catch (e) {}
            document.body.removeChild(textarea)
        }
    }
    render() {
        const isAdjustMode = Boolean(this.props.selectedText) && !this.state.forceStandardMode
        let okToSubmit = isAdjustMode
            ? this.state.text && this.state.text.length > 3
            : this.state.text &&
              this.state.text.length > 10 &&
              this.state.industry &&
              this.state.contentType &&
              this.state.contentTone
        let wordCount = this.state.text.split(' ').length - 1
        if (wordCount < 0) wordCount = 0
        let tooManyWords = wordCount > 500
        if (tooManyWords) okToSubmit = false
        let contentTypes = [
            {
                label: i18n.t('templates:aiContentAssistant.contentTypes.subjectLine'),
                value: 'subject'
            },
            {
                label: i18n.t('templates:aiContentAssistant.contentTypes.heading'),
                value: 'heading'
            },
            {
                label: i18n.t('templates:aiContentAssistant.contentTypes.paragraph'),
                value: 'paragraph'
            },
            {
                label: i18n.t('templates:aiContentAssistant.contentTypes.article'),
                value: 'article'
            }
        ]

        let contentTones = [
            {
                label: i18n.t('templates:aiContentAssistant.contentTones.professional'),
                value: 'professional'
            },
            {
                label: i18n.t('templates:aiContentAssistant.contentTones.casual'),
                value: 'casual'
            },
            {
                label: i18n.t('templates:aiContentAssistant.contentTones.conversational'),
                value: 'conversational'
            },
            {
                label: i18n.t('templates:aiContentAssistant.contentTones.direct'),
                value: 'direct'
            },
            {
                label: i18n.t('templates:aiContentAssistant.contentTones.expert'),
                value: 'expert'
            },
            {
                label: i18n.t('templates:aiContentAssistant.contentTones.friendly'),
                value: 'friendly'
            }
        ]

        if (this.props.contentType === 'social post') {
            contentTypes.push({ label: 'Social Post', value: 'social post' })
        }

        if (this.props.contentType === 'sms') {
            contentTypes.push({ label: 'SMS', value: 'sms' })
        }

        let header = (
            <div style={{ flex: '0' }}>
                <div
                    style={{ display: 'flex', justifyContent: 'space-between', alignContent: 'center' }}
                    className='mar-b25'
                >
                    <Button
                        className='button-darkmode-trans'
                        text={i18n.t('templates:aiContentAssistant.close')}
                        iconLeft={<Icons icon='cross' color='#FFFFFF' />}
                        onClick={this.props.close}
                        postHogTag='ai-content-assistant-close'
                    />
                    {!this.state.showHistory && this.state.historyCnt > 0 && (
                        <div style={{ display: 'flex', alignItems: 'center', gap: '24px' }}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                <span className='text-grey' style={{ fontSize: '12px' }}>
                                    Share feedback
                                </span>
                                <Button
                                    className='button-sml button-opaque'
                                    style={{ padding: '2px 8px' }}
                                    disabled={this.state.generatingText}
                                    onClick={() => {}}
                                    postHogTag='posthog-survey-content-assistant-positive'
                                >
                                    <Icons
                                        icon='thumbsUp'
                                        color='var(--neutral-0)'
                                        style={{ height: 16, width: 16 }}
                                    />
                                </Button>
                                <Button
                                    className='button-sml button-opaque'
                                    style={{ padding: '2px 8px' }}
                                    disabled={this.state.generatingText}
                                    onClick={() => {}}
                                    postHogTag='posthog-survey-content-assistant-negative'
                                >
                                    <Icons
                                        icon='thumbsDown'
                                        color='var(--neutral-0)'
                                        style={{ height: 16, width: 16 }}
                                    />
                                </Button>
                            </div>
                            <Button
                                className='button-darkmode'
                                text={i18n.t('templates:aiContentAssistant.history')}
                                iconLeft={<Icons icon='history' color='#FFFFFF' />}
                                onClick={this.getHistory}
                                disabled={this.state.generatingText}
                                postHogTag='ai-content-assistant-history'
                            />
                        </div>
                    )}
                    {this.state.showHistory && (
                        <>
                            <Button
                                className='button-darkmode'
                                text={i18n.t('templates:aiContentAssistant.backToAiContentAssistant')}
                                iconLeft={<Icons icon='arrowLeft' color='#FFFFFF' />}
                                onClick={() => {
                                    this.setState({ showHistory: false })
                                }}
                                postHogTag='ai-content-assistant-history-back'
                            />
                        </>
                    )}
                </div>
                {!this.state.showHistory && (
                    <h3 className='mar-b25' style={{ display: 'flex', alignItems: 'center' }}>
                        <Icons icon='sparkle2' style={{ width: '30px', height: '35px' }} className='mar-r10' />
                        <div>{i18n.t('templates:aiContentAssistant.aiContentAssistant')}</div>
                    </h3>
                )}
                {this.state.showHistory && (
                    <h3 className='mar-b25' style={{ display: 'flex', alignItems: 'center' }}>
                        <Icons icon='history' style={{ width: '30px', height: '35px' }} className='mar-r10' />
                        <div>{i18n.t('templates:aiContentAssistant.history')}</div>
                    </h3>
                )}
            </div>
        )

        let footer = (
            <div style={{ flex: '0', fontSize: '13px', color: 'var(--neutral-400)' }}>
                {i18n.t('templates:aiContentAssistant.aiFooter')}
            </div>
        )
        const { drawerProperties } = this.state

        // Reusable quick actions component
        let quickActions = (
            <div className='mar-b15'>
                <div className='text-grey' style={{ marginBottom: '12px' }}>
                    {isAdjustMode
                        ? 'Quick actions'
                        : i18n.t('templates:aiContentAssistant.aiContentAssistantAdjustments')}
                </div>
                <div className='quickFlex' style={{ gap: '8px', flexWrap: 'wrap', alignItems: 'center' }}>
                    <Select
                        outerstyle={{ display: 'inline-block' }}
                        outerClassName='select-darkmode'
                        dropDownClassName='dropdown-darkmode'
                        className='button-darkmode button-xs button-rounded'
                        dropDownParentProperties={drawerProperties}
                        placeholder={'Change Tone'}
                        data={contentTones}
                        value={undefined}
                        onChange={(ev) => {
                            this.generateText('changeTone', ev.currentTarget.value)
                        }}
                        postHogTag='ai-content-assistant-change-tone'
                    />
                    <Select
                        outerstyle={{ display: 'inline-block' }}
                        outerClassName='select-darkmode'
                        dropDownClassName='dropdown-darkmode'
                        className='button-darkmode button-xs button-rounded'
                        dropDownParentProperties={drawerProperties}
                        placeholder={'Translate'}
                        data={[
                            { label: 'English', value: 'English' },
                            { label: 'French', value: 'French' },
                            { label: 'German', value: 'German' },
                            { label: 'Spanish', value: 'Spanish' },
                            { label: 'Portuguese', value: 'Portuguese' },
                            { label: 'Italian', value: 'Italian' },
                            { label: 'Dutch', value: 'Dutch' },
                            { label: 'Finnish', value: 'Finnish' },
                            { label: 'Norwegian', value: 'Norwegian' },
                            { label: 'Swedish', value: 'Swedish' }
                        ]}
                        value={undefined}
                        onChange={(ev) => {
                            this.generateText('translate', ev.currentTarget.value)
                        }}
                        postHogTag='ai-content-assistant-translate'
                    />
                    <Button
                        className='button-darkmode button-xs button-rounded'
                        text={'Shorten'}
                        onClick={() => {
                            this.generateText('shorten')
                        }}
                        postHogTag='ai-content-assistant-shorten'
                        style={{ fontWeight: 400 }}
                    />
                    <Button
                        className='button-darkmode button-xs button-rounded'
                        text={'Rephrase'}
                        onClick={() => {
                            this.generateText('rephrase')
                        }}
                        postHogTag='ai-content-assistant-rephrase'
                        style={{ fontWeight: 400 }}
                    />
                    <Button
                        className='button-darkmode button-xs button-rounded'
                        text={'Elaborate'}
                        onClick={() => {
                            this.generateText('expand')
                        }}
                        postHogTag='ai-content-assistant-elaborate'
                        style={{ fontWeight: 400 }}
                    />
                    <Button
                        className='button-darkmode button-xs button-rounded'
                        text={'Fix Spelling and Grammar'}
                        onClick={() => {
                            this.generateText('fix-grammar')
                        }}
                        postHogTag='ai-content-assistant-fix-grammar'
                        style={{ fontWeight: 400 }}
                    />
                </div>
            </div>
        )

        let main = (
            <div style={{ flex: '1' }} ref={this.mainRef}>
                {isAdjustMode && (
                    <div
                        className='mar-b25'
                        style={{
                            backgroundColor: 'white',
                            borderRadius: '16px',
                            padding: '16px',
                            color: 'var(--neutral-950)'
                        }}
                    >
                        <div className='text-grey mar-b5'>Selected content</div>
                        <div style={{ whiteSpace: 'pre-wrap' }}>{this.props.selectedText}</div>
                    </div>
                )}

                {!isAdjustMode && (
                    <div className='mar-b25' style={{ fontSize: '18px', lineHeight: '28px' }}>
                        {i18n.t('templates:aiContentAssistant.iWouldLikeToWriteA')}
                        <Select
                            outerstyle={{ display: 'inline-block' }}
                            outerClassName='select-darkmode mar-l10'
                            dropDownParentProperties={drawerProperties}
                            dropDownClassName='dropdown-darkmode'
                            className='button-darkmode button-xs button-rounded'
                            data={contentTones}
                            type='text'
                            name='contentTone'
                            value={this.state.contentTone}
                            onChange={this.updateInput}
                        />
                        <Select
                            outerstyle={{ display: 'inline-block' }}
                            outerClassName='select-darkmode mar-r10 mar-l10'
                            dropDownParentProperties={drawerProperties}
                            dropDownClassName='dropdown-darkmode'
                            className='button-darkmode button-xs button-rounded'
                            data={contentTypes}
                            type='text'
                            name='contentType'
                            value={this.state.contentType}
                            onChange={this.updateInput}
                        />
                        {i18n.t('templates:aiContentAssistant.relatedToThe')}
                        <Select
                            outerstyle={{ display: 'inline-block' }}
                            outerClassName='select-darkmode mar-r10 mar-l10'
                            dropDownParentProperties={drawerProperties}
                            dropDownClassName='dropdown-darkmode'
                            className='button-darkmode button-xs button-rounded'
                            data={Industries.industryArray()}
                            type='text'
                            name='industry'
                            value={this.state.industry}
                            onChange={this.updateInput}
                        />
                        {i18n.t('templates:aiContentAssistant.industry')}.
                    </div>
                )}

                <div
                    style={{
                        display: 'flex',
                        position: 'relative',
                        flexDirection: 'column',
                        overflow: 'hidden',
                        padding: '15px'
                    }}
                    className='mar-b25 border-darkmode-light-to-dark'
                >
                    <div
                        style={{
                            backgroundColor: 'black',
                            position: 'absolute',
                            right: '30px',
                            top: '5px',
                            fontSize: '10px',
                            zIndex: '1'
                        }}
                    >
                        <span style={{ color: tooManyWords ? 'red' : '' }}>{wordCount}</span>
                        <span> / 500</span>
                    </div>

                    <TextArea
                        className='txtInput-darkMode'
                        placeholder={
                            isAdjustMode
                                ? 'How would you like to adjust this content?'
                                : i18n.t('templates:aiContentAssistant.whatDoYouWantToWriteAbout')
                        }
                        style={{ border: '0px', resize: 'none' }}
                        value={this.state.text}
                        onChange={this.updateInput}
                        name='text'
                        error={this.state.generatingTextError}
                    />

                    <div
                        className='quickFlex'
                        style={{ width: '100%', alignItems: 'flex-end', justifyContent: 'space-between' }}
                    >
                        <Button
                            style={{ textAlign: 'center', background: 'none' }}
                            text={i18n.t('templates:aiContentAssistant.generateContent')}
                            disabled={!okToSubmit}
                            onClick={() => this.generateText('new')}
                            className='button-darkmode  border-darkmode-purple-to-blue-horizontal'
                            postHogTag='ai-content-assistant-generate-content'
                        />
                        <span style={{ fontSize: '12px', marginRight: '8px' }}>
                            {this.state.remaining}/{this.state.allowedLookUps} uses left this month{' '}
                            <a
                                href='/cp/company/subscription'
                                style={{ color: '#ffffff' }}
                                data-ph='ai-content-assistant-upgrade-for-more-uses'
                            >
                                Upgrade for more uses
                            </a>
                        </span>
                    </div>
                </div>

                {isAdjustMode && quickActions}
            </div>
        )

        let loading = (
            <div
                style={{
                    flex: '1',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    flexDirection: 'column'
                }}
            >
                <>
                    <AiLoadingIcon style={{ height: '200px', width: '400px' }} />
                    <div>{i18n.t('templates:aiContentAssistant.aiGeneratingContent')}...</div>
                </>
            </div>
        )

        let results = (
            <div style={{ flex: '1', display: 'flex', flexDirection: 'column' }}>
                <div style={{ flex: '1' }}>
                    <div
                        className='mar-b25'
                        style={{
                            backgroundColor: 'white',
                            borderRadius: '16px',
                            padding: '16px',
                            color: 'var(--neutral-950)'
                        }}
                    >
                        <div className='text-grey mar-b5'>Generated content</div>
                        <div
                            style={{
                                maxHeight: 'calc(100vh - 400px)',
                                border: '0',
                                overflow: 'auto',
                                marginBottom: '12px'
                            }}
                            dangerouslySetInnerHTML={{ __html: this.state.generatedText }}
                        ></div>
                        <div style={{ display: 'flex', gap: '8px' }}>
                            <Button
                                className='button-darkmode button-sml border-darkmode-purple-to-blue-horizontal'
                                text={
                                    isAdjustMode
                                        ? i18n.t('templates:aiContentAssistant.updateContent')
                                        : i18n.t('templates:aiContentAssistant.insertContent')
                                }
                                iconLeft={
                                    <Icons
                                        icon='plus'
                                        color='var(--neutral-0)'
                                        style={{ height: 16, width: 16 }}
                                    />
                                }
                                onClick={() => {
                                    this.goInsert(this.state.generatedText)
                                }}
                                postHogTag={
                                    isAdjustMode
                                        ? 'ai-content-assistant-update-content'
                                        : 'ai-content-assistant-insert-content'
                                }
                            />
                            <Button
                                className='button-sml'
                                text={i18n.t('templates:aiContentAssistant.copy')}
                                iconLeft={<Icons icon='copyClipboard' style={{ height: 16, width: 16 }} />}
                                onClick={this.copyGenerated}
                                postHogTag='ai-content-assistant-copy-content'
                            />
                        </div>
                    </div>

                    <div
                        style={{
                            display: 'flex',
                            position: 'relative',
                            flexDirection: 'column',
                            overflow: 'hidden',
                            padding: '15px'
                        }}
                        className='mar-b25 border-darkmode-light-to-dark'
                    >
                        <div
                            style={{
                                backgroundColor: 'black',
                                position: 'absolute',
                                right: '30px',
                                top: '5px',
                                fontSize: '10px',
                                zIndex: '1'
                            }}
                        >
                            <span style={{ color: tooManyWords ? 'red' : '' }}>{wordCount}</span>
                            <span> / 500</span>
                        </div>

                        <TextArea
                            className='txtInput-darkMode'
                            placeholder='How would you like to adjust this content?'
                            style={{ height: '120px', border: '0px', resize: 'none' }}
                            value={this.state.text}
                            onChange={this.updateInput}
                            name='text'
                            error={this.state.generatingTextError}
                        />

                        <div
                            className='quickFlex'
                            style={{ width: '100%', alignItems: 'flex-end', justifyContent: 'space-between' }}
                        >
                            <Button
                                style={{ textAlign: 'center', background: 'none' }}
                                text={i18n.t('templates:aiContentAssistant.generateContent')}
                                disabled={!okToSubmit}
                                onClick={() => this.generateText('adjust')}
                                className='button-darkmode  border-darkmode-purple-to-blue-horizontal'
                                postHogTag='ai-content-assistant-generate-content'
                            />
                            <span style={{ fontSize: '12px', marginRight: '8px' }}>
                                {this.state.lookUpsthisMonth}/{this.state.allowedLookUps} uses left this month{' '}
                                <a
                                    href='/cp/company/subscription'
                                    style={{ color: '#ffffff' }}
                                    data-ph='ai-content-assistant-upgrade-for-more-uses'
                                >
                                    Upgrade for more uses
                                </a>
                            </span>
                        </div>
                    </div>

                    {quickActions}
                </div>

                <div style={{ flex: '0' }} className='mar-b25'>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <Button
                            className='button-darkmode-trans'
                            iconLeft={<Icons icon='arrowLeft' color='#FFFFFF' />}
                            text={i18n.t('templates:aiContentAssistant.tryAnotherPrompt')}
                            onClick={this.tryAgain}
                        />
                    </div>
                </div>
            </div>
        )

        let history = (
            <div style={{ flex: '1', overflow: 'auto', marginBottom: '15px' }}>
                {this.state.history.map((line, index) => {
                    let isLast = index == this.state.history.length - 1
                    return (
                        <div
                            key={'hist_' + index}
                            style={{ display: 'flex', flexDirection: 'row', marginRight: '15px' }}
                        >
                            <div className='mar-r10' style={{ flex: '0', display: 'flex', flexDirection: 'column' }}>
                                <div
                                    style={{
                                        marginTop: '5px',
                                        width: '10px',
                                        height: '10px',
                                        background: 'white',
                                        borderRadius: '2px',
                                        display: 'block'
                                    }}
                                ></div>
                                {!isLast && (
                                    <div
                                        style={{
                                            flex: '1',
                                            borderLeft: '1px dashed var(--neutral-700)',
                                            marginLeft: '50%'
                                        }}
                                    ></div>
                                )}
                            </div>
                            <div style={{ flex: '1', paddingBottom: '40px' }}>
                                <div
                                    style={{
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        alignItems: 'flex-start',
                                        gap: '16px'
                                    }}
                                    className='mar-b10'
                                >
                                    <div style={{ flex: 1 }}>
                                        <div className='text-heavy'>"{line.prompt}"</div>
                                        {line.contentType !== 'none' && line.industry !== 'none' && (
                                            <div className='text-grey'>
                                                <span style={{ textTransform: 'capitalize' }}>{line.contentType}</span>{' '}
                                                ・ <span style={{ textTransform: 'capitalize' }}>{line.industry}</span>
                                            </div>
                                        )}
                                    </div>
                                    <div style={{ flex: '0 0 300' }}>
                                        <Button
                                            text={i18n.t('templates:aiContentAssistant.addToContent')}
                                            className='button-darkmode border-darkmode-purple-to-blue-horizontal'
                                            iconLeft={
                                                <Icons
                                                    icon='plus'
                                                    color='var(--neutral-0)'
                                                    style={{ height: 20, width: 20 }}
                                                />
                                            }
                                            onClick={() => {
                                                this.goInsert(line.result)
                                            }}
                                            postHogTag='ai-content-assistant-history-add-to-content'
                                        />
                                    </div>
                                </div>
                                <div dangerouslySetInnerHTML={{ __html: line.result }}></div>
                            </div>
                        </div>
                    )
                })}
            </div>
        )
        return (
            <>
                <div style={{ display: 'flex', flexDirection: 'column', height: 'calc(100vh - 50px)' }}>
                    {header}
                    {this.state.errorHolder && this.state.errorHolder}
                    {!this.state.errorHolder && !this.state.showHistory && this.state.generatingText && <>{loading}</>}
                    {!this.state.errorHolder && !this.state.showHistory && this.state.hasGeneratedText && (
                        <>{results}</>
                    )}
                    {!this.state.errorHolder &&
                        !this.state.showHistory &&
                        !this.state.generatingText &&
                        !this.state.hasGeneratedText && <>{main}</>}
                    {!this.state.errorHolder && this.state.showHistory && <>{history}</>}
                    {footer}
                    {this.state.approveDrawer}
                </div>
            </>
        )
    }
}

export default AiContentGenerator
